__webpack_require__.p = "/cw_react_horoscope/";